const updates = [
  {
    date: '2026-07-30',
    title: '暑期档重磅推荐：《星际征途3》4K蓝光版已上线',
    desc: '年度科幻巨制火热更新中，支持4K HDR与杜比全景声，91影视看片app独家首发高清片源。',
    tag: '新片上线',
  },
  {
    date: '2026-07-28',
    title: '热门剧集《长安十二时辰》第二季全集一次性放出',
    desc: '高清电视剧免费全集完整上线，蓝光影视资源级别画质，剧情紧凑好评如潮。',
    tag: '剧集更新',
  },
  {
    date: '2026-07-25',
    title: '播放器全面升级：超清综艺播放体验再提升',
    desc: '新版播放引擎上线，支持智能码率自适应，弱网环境下仍可保持高清流畅不缓冲。',
    tag: '功能升级',
  },
  {
    date: '2026-07-22',
    title: '2026上半年高分电影榜单正式发布',
    desc: '综合豆瓣、IMDb评分，精选30部年度必看佳作，高清电影在线观看一网打尽。',
    tag: '榜单发布',
  },
  {
    date: '2026-07-18',
    title: '纪录片专区扩容：新增200+蓝光自然纪录片',
    desc: '涵盖BBC、国家地理等顶级制作，高清影视大全再添重磅内容板块。',
    tag: '内容上新',
  },
  {
    date: '2026-07-15',
    title: '日韩剧场上线：热门日剧韩剧同步更新',
    desc: '追剧党福音，高清电视剧免费全集在线看，从此不愁没剧追。',
    tag: '新频道',
  },
  {
    date: '2026-07-10',
    title: '经典港片修复计划启动：首批50部蓝光重制',
    desc: '周星驰、成龙、周润发等经典作品以蓝光影视资源画质重新上线。',
    tag: '经典重制',
  },
  {
    date: '2026-07-05',
    title: '91影视看片app注册用户突破500万',
    desc: '感谢每一位用户的支持，我们将持续提供更丰富的高清片源和更流畅的播放体验。',
    tag: '里程碑',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">最新动态</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">关注91影视最新片源更新与平台动态</p>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2 hidden md:block"></div>

          <div className="flex flex-col gap-6">
            {updates.map((item, i) => (
              <div key={i} className={`flex flex-col md:flex-row gap-4 md:gap-8 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                  <div className={`hidden md:flex items-center gap-2 ${i % 2 === 0 ? 'justify-end' : 'justify-start'}`}>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>

                <div className="hidden md:flex items-center justify-center relative z-10">
                  <div className="w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                </div>

                <div className="flex-1 pl-8 md:pl-0 relative">
                  <div className="md:hidden absolute left-0 top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50 z-10"></div>
                  <div className="md:hidden flex items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}